<template>
  <div class="create-or-join">
    <div class="el-icon-back back" @click="back"><span>加入/创建企业</span></div>
    <div class="main">
      <div class="select-item" @click="goto('JoinCompany')">
        <div class="item-main">
          <div class="item-title">
            <div class="prefix" style="background:#1989FA"></div>
            <span>加入企业</span>
          </div>
          <div class="item-content">
            如果你的企业已在使用轻单,可以通过填写企业编号加入你的企业。
          </div>
        </div>
        <div class="el-icon-arrow-right"></div>
      </div>
      <div class="select-item" @click="goto('CreateCompany')">
        <div class="item-main">
          <div class="item-title">
            <div class="prefix" style="background:#69E0AF"></div>
            <span>创建企业</span>
          </div>
          <div class="item-content">新企业创建后, 你将作为管理员, 添加成员、管理企业组织结构。</div>
        </div>
        <div class="el-icon-arrow-right"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "create-or-join",
  methods: {
    back() {
      this.$router.go(-1)
    },
    goto(address) {
      this.$router.push({ path: "/" + address })
    }
  }
}
</script>
<style lang="scss" scoped>
.create-or-join {
  height: 100vh;
  width: 100%;
  background: #f5f5f5;
  @include flex-center;
  .back {
    position: fixed;
    z-index: 10;
    left: 40px;
    top: 48px;
    font-size: 18px;
    color: #606266;
    line-height: 28px;
    cursor: pointer;
    span {
      margin-left: 5px;
    }
  }
  .main {
    .select-item {
      cursor: pointer;
      width: 448px;
      height: 122px;
      background: #ffffff;
      border-radius: 10px;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .item-main {
        padding: 24px 30px;
        .item-title {
          display: flex;
          align-items: center;
          .prefix {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
        .item-content {
          width: 357px;
          margin-top: 8px;
          font-size: 14px;
          color: rgba(96, 98, 102, 0.8);
        }
      }
    }
  }
}
</style>
